<template>
  <div class="basic_con">
    <Frame title="常用联系人" :typeSameLine="true">
      <template slot="contentSlot">
        <div class="con_wrapper">
          <div class="factoring-container">
            <div class="project-table">
              <avue-crud
                ref="crud"
                :option="tableConfig"
                :data="tableData"
                v-model="form"
                :page.sync="page"
                :search.sync="searchForm"
                :table-loading="loading"
                @on-load="queryTableData"
                @search-change="searchChange"
                @sort-change="sortChange"
                @selection-change="selectionChange"
                @row-save="rowSave"
                @row-update="rowUpdate"
              >
                <template slot="menuRight">
                  <el-button
                    type="primary"
                    size="small"
                    icon="el-icon-plus"
                    v-if="!readOnly"
                    @click.stop="handleAdd()"
                    >添加联系人
                  </el-button>
                  <el-button
                    size="small"
                    icon="el-icon-edit"
                    plain
                    v-if="!readOnly"
                    @click.stop="handleEdit()"
                    >修改
                  </el-button>
                  <el-button
                    size="small"
                    icon="el-icon-delete"
                    plain
                    v-if="!readOnly"
                    @click.stop="handleDelete()"
                    >删除
                  </el-button>
                </template>
              </avue-crud>
            </div>
          </div>
        </div>
      </template>
    </Frame>
  </div>
</template>

<script>
import Frame from "../../frame.vue";
import { contactsConfig } from "./config";
import * as api from "@/api/factoring/factoringCustomer";

export default {
  name: "contacts",
  components: {
    Frame,
  },
  data() {
    return {
      selectionList: [],
      checkUserList: [],
      checkdepartment: [],
      form: {},
      // filterSearchForm: {},
      files: "",
      drawer: false,
      id: "",
      tableConfig: contactsConfig(this.getMoney),
      sortOption: "",
      optionColumn: {},
      tableData: [],
      page: {
        currentPage: 1,
        total: 0,
        layout: "total,pager,prev, next",
        background: false,
        pageSize: 10,
      },
      loading: false,
    };
  },
  mounted() {
    this.sortOption = this.tableConfig.column;
    // this.queryTableData();
  },
  props: {
    readOnly: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    selectionChange(list) {
      this.selectionList = list;
    },

    saveData(row) {
      this.$refs.cloudtage.save(row);
    },

    searchChange(str, done) {
      this.queryTableData();
      done();
    },

    async queryTableData() {
      this.loading = true;
      let params = {
        current: this.page.currentPage,
        size: this.page.pageSize,
        custId: this.$route.params.id,
      };
      let res = await api.getCustcontactbl(params);
      if (res.data.code == 200) {
        let data = res.data.data.records;

        this.tableData = data;
        this.page.total = res.data.data.total;
        this.loading = false;
      } else {
        this.$message.error(res.data.msg);
        this.loading = false;
      }
    },

    //新增
    handleAdd() {
      this.$refs.crud.rowAdd();
    },
    //新增
    rowSave(row, done, loading) {
      this.submitCustcarbl(row, done, loading);
    },
    //修改
    rowUpdate(row, index, done, loading) {
      this.submitCustcarbl(row, done, loading);
    },
    // 新增修改 接口
    submitCustcarbl(row, done, loading) {
      let data = {
        contactName: row.contactName,
        contactDuty: row.contactDuty,
        contactCompanyphone: row.contactCompanyphone,
        contactMobilephone: row.contactMobilephone,
        contactWechat: row.contactWechat,
        isRepresent: row.isRepresent,
        isImportant: row.isImportant,
        contactPhone: row.contactPhone,
        email: row.email,
        id: row.id,
        custId: this.$route.params.id,
      };
      api.submitCustcontactbl(data).then(
        () => {
          this.$message({
            type: "success",
            message: "操作成功!",
          });
          // 数据回调进行刷新
          done(row);
          this.queryTableData();
        },
        (error) => {
          window.console.log(error);
          loading();
        }
      );
    },
    handleEdit() {
      if (this.selectionList.length > 1) {
        this.$message.error("只能选择一条数据进行编辑");
      } else if (this.selectionList.length == 1) {
        let data = this.selectionList[0];
        data.originMoneyF = data.originMoney;
        data.marketMoneyF = data.marketMoney;
        this.$refs.crud.rowEdit(data);
      } else {
        this.$message.error("请选择一条数据进行编辑");
      }
    },

    handleDelete() {
      let self = this;

      this.$confirm("确定删除选择的数据?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async () => {
          console.log("删除");
          let ids = this.selectionList.map((item) => {
            return item.id;
          });
          let res = await api.removeCustcontactbl({ ids: ids.join(",") });
          if (res.data.code == 200) {
            self.$message({
              type: "success",
              message: "删除成功",
            });
            self.queryTableData();
          }
        })
        .catch(() => {});
    },
  },
};
</script>
<style scoped lang="scss">
.basic_con {
  width: 100%;
  margin-top: 20px;
  background-color: #fff;
  border-radius: 10px;
}
</style>

